module.exports = __webpack_public_path__ + "files/ec6056ecd00a58cd3d33b0a2a472a6f8.png";